import Section from '@components/common/Section/Section'
import SublimeMedia from '@components/common/SublimeMedia/SublimeMedia'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import { CSSProperties, FC } from 'react'
import { MediaPicker } from 'types/mediaPicker'
import FaqFilter from '../FaqModule/FaqFilter/FaqFilter'
import { FaqSection } from '../FaqModule/FaqModule'
import styles from './ContactComponent.module.scss'

type ContactComponentProps = {
  title?: string
  enableFilter?: boolean
  backgroundColorPicker?: string
  sections?: ContactSection[]
}

interface ContactSection {
  title?: string
  teaser: string
  contacts: ContactPerson[]
}

interface ContactPerson {
  image: MediaPicker
  body: string
}

const ContactComponent: FC<ContactComponentProps> = ({
  title,
  enableFilter,
  backgroundColorPicker,
  sections,
}) => {
  return sections ? (
    <Section
      sectionClasseName={styles.root}
      style={{ '--bg-color': backgroundColorPicker } as CSSProperties}
    >
      {title && <h1 className={'headerOne text-center'}>{title}</h1>}
      {enableFilter && (
        <FaqFilter
          sections={sections
            .map((section) => {
              return { title: section.title } as FaqSection
            })
            .filter((section) => section.title && section.title.length > 0)}
        />
      )}

      <div className={styles.sections}>
        {sections.map((section) => (
          <div
            key={section.title}
            className={styles.section}
            id={`${section.title}`}
          >
            <div className={styles.sectionTitle}>
              {section.title && <h1 className="bodyText">{section.title}</h1>}
              {section.teaser && (
                <h2 className="headerTwo">{section.teaser}</h2>
              )}
            </div>

            <div className={styles.contacts}>
              {section.contacts &&
                section.contacts.map((contact, index) => (
                  <div key={index} className={styles.contact}>
                    <div className={styles.contactImage}>
                      <SublimeMedia
                        layout="responsive"
                        mediaPicker={contact.image}
                      />
                    </div>
                    <TrustedHtml
                      className={styles.contactBody}
                      html={contact.body}
                    />
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </Section>
  ) : (
    <></>
  )
}

export default ContactComponent
